import axios from 'axios'
import ParamUtils from '@/core/utils/ParamUtils'

class CompraDiretaApiClient {

    async buscarParametros() {
        return await axios.get('/compra-direta/api/v1/compras-diretas/parametros')
    }

    async buscarLinguagem() {
        return await axios.get('/compra-direta/api/v1/compras-diretas/linguagem')
    }

    async baixarRelatorioDaAta(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/compras-diretas/${compraDiretaId}/ata`,
            {
                responseType: 'arraybuffer'
            })
    }

    async buscarAvancadaComprasDiretas(filtros, paginacao) {
        return await axios.get('/compra-direta/api/v1/compras-diretas/busca-avancada' +
            `?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async marcarNotificacaoLida(notificacaoId) {
        await axios.put(`/compra-direta/api/v1/notificacoes/${notificacaoId}/marcar-lida`)
    }

    async contarMensagensCentralChat(compraDiretaId, origemMensagem) {
        return await axios.get(`/compra-direta/api/v1/compras-diretas/${compraDiretaId}/contar-mensagens-nao-lidas?origemMensagem=${origemMensagem}`)
    }

    async contarMensagensNaoLidasItensLotes(compraDiretaId, origemMensagem) {
        return await axios.get(`/compra-direta/api/v1/compras-diretas/${compraDiretaId}/mensagens/contar-para-itens-lotes?origemMensagem=${origemMensagem}`)
    }

    async marcarMensagensLidasItensLotes({ compraDiretaId, itemOuLoteId, origemMensagem, tipo}) {
        return await axios.patch(`/compra-direta/api/v1/compras-diretas/${compraDiretaId}/itens-lotes/${itemOuLoteId}/mensagens/marcar-como-lidas?origemMensagem=${origemMensagem}&tipo=${tipo}`)
    }
}

export default new CompraDiretaApiClient()
